import * as React from "react";
import { connect } from "react-redux";
import { actions as nameActions } from 'src/actions/name.actions';
import { actions } from 'src/actions/main.actions';
import { actions as homeActions } from 'src/actions/home.actions';
import Icon from 'src/core/ui/icon';
import AnimateLoad  from 'src/core/ui/animate-wrapper';
import { TransitionMotion } from 'react-motion';

import {TransitionGroup, CSSTransition} from 'react-transition-group';
import * as ReactDOM from "react-dom";

interface IToastsProps{
    messages: { [id: string] : { title: string, description: any, type: 'success'|'error'|'info'|'warn', deadline: number }}
    onDelete: (id?: string) => void;
}

interface IToastsState{
  }

export default class Toasts extends React.Component<IToastsProps & typeof actions & typeof homeActions, IToastsState>{

    constructor(props: any){
    super(props);
        this.state =  {
        }
    }

    willLeave = () => {
        return {};
    }

    public render(){

        const {messages} = this.props;
        
        console.log(messages);

        return ReactDOM.createPortal(
                <TransitionGroup className='toast-container'>
                {
                    Object.keys(messages).map((item, index) => {
                        
                        const message = messages[item];

                        return (<CSSTransition
                                timeout={500}
                                classNames='toast'
                                key={item}
                        >
                            
                            <div key={'toast' + item} className={'toast ' + message.type}>
                                <h3>{message.title} <Icon onClick={() => this.props.onDelete(item)} style={{ color: 'white', cursor: 'pointer'}} type='close' /></h3>
                                <div>
                                    {
                                    message.description instanceof Array
                                    ? <ul>{message.description.map((single, item) => <li key={single}>{single}</li>)}</ul>:
                                    <div dangerouslySetInnerHTML={{__html: message.description}}></div>
                                    }
                                </div>
                            </div>

                        </CSSTransition>
                        );
                    })
                }
                </TransitionGroup>, document.getElementById("notify-root") as any
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/toasts/toast.tsx